import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { contactInfo } from '../data/mock';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { sectionId } from '../utils/routes';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// SVG Map of Switzerland - REAL accurate outline
const SwitzerlandMap = () => (
  <svg viewBox="0 0 1000 641" className="w-full h-auto opacity-30 group-hover:opacity-50 transition-opacity duration-700">
    <path
      d="M952 307.7l-1.1 9.4-0.7 2.7-1.2 1.9-4.4 5.3 0.4 4.4 1.4 4.2 0.5 4.1-2.4 3.7-3.4 2.2-0.9 2.7 0.2 3.3-0.4 4.2-1.9 3.5-2.2 2.1-1 2.7 1.7 5.7 3.6 4.2 8.6 0.9 4.2 3.6 1.5 5.6-0.1 7.6-1.6 7.3-1.2 2-1.6 2.6-3.7 0.7-14.4-3.8-7 0.7-2.6-0.4-2.3-1.1-1.2-1.3-1.1-1.5-1.6-1.4-8.3-2.9-0.9-3.1 1.1-6.1-0.4-3.3-3.2-2.6-5.2 0-19 5.5-2 1.1-0.9 2.2-2.4 9.5-1.7 2.3-4.3 4.3-1.8 2.6-0.2 2.1-0.1 6.5-0.9 3.1 0.3 2.7 0.5 2.1 0.9 1.7 1.8 1.2-3.6 6 3.2 4 5.9 2.3 9 1.7 3.5 1.4 1.5 3.3-1.5 6.4-1.5 1.9-4.2 3.8-1.5 2.9-1.1 3.9-0.1 2.7 0.8 2.4 1.9 3.3 8.3 8.5 2.6 5.2-2.7 5.5-5.6 3.6-8.5 3.2-6.7-0.1-0.1-6.6-2.1-4.9-7.9-7.1-3-4-1.3-6.4-0.1-5.8-1.3-4.7-5.1-3.4-4.1-1-3.9-0.3-8.8 1.5-13.4 6.9-4.2 1.4-2.6-0.6-4.9-3-2.2 0-2.2 2.5-0.4 3.3 0.4 3.3-0.1 2.3-3.1 4.3-3.8 1.5-23.1-0.3-4.7-1.7-4.2-2.9-2.6-3.5-4-10.5-1.8-1.5-4.5-2.5-1.4-1.4-0.4-1.7 0.3-4.4-1.2-28.1-0.7-1.8-1.6 0.3-3.2 2.4-1.4 1.9-0.7 2.1-1 1.7-2.2 0.9-1.5-0.6-5.1-5-0.2-3.6-4-1-9.8 1.2-3.8 3.5-3.5 7.1-1.6 7.2 1.9 3.9 2.7 1.9 0.4 2.9-0.5 3.7 0 4.2 2.7 10.3 0.3 3.8-1.3 6.4-5.9 12.3-3 10.5-1.8 2.9-2.3 2.2-2.4 1.2-2.2 1.6-1.2 2.9-0.9 3.3-1.5 2.8-0.1 0.2-14.6 10-3.7 5.6-0.8 3.7 0.4 6.6-0.6 3.5-1.6 2.7-2 1.2-4.4 1.4-5.1 4-0.9 3.3 3.6 10.1-6.7 6.1-0.4 0.7-0.1 0.8 0.1 0.7 0.4 0.7 2.2 2.2 1.7 5.3 1.8 2.7 2 1.2 4.4 0.8 1.9 1.3 2.2 4.8-0.7 4.9-5 9.8-6.5 7.9-6-1.1-6.6-3-8 2.5 0.7-4.5 1.2-3.4 0.9-3.6-0.4-5-1.1-3.8-1.7-3.8-3.5-6.2-2-4.7-1.3-1.8-1.3-1.1-11.6-6.2-3.1-1.1-3.4-0.2 0.3-0.8 0.8-1.4 3.5-8.1 5.8-7.1 3-6.8-5.2-6.8-3-1-6.2 0.1-3.2-0.4-1.6-1.1-1.4-2.7-0.7-0.2-1-0.4-1.2 0.6-3.2 2.7-1.4 0.9-3.6-0.2-9.3-5.5-3.9-1.4-2-1-12.7-18.8-5.7-5.9-5.6-2.8-5.3-2.2-3.7-3-2.2-4.7-0.8-7.1 0.7-7.5 3.3-15.1 0.7-8.5-0.1-8.8-0.9-6.6-2.7-4-5.8-1-2.7 0.6-8.6 1.8-5.4 3-4.3 4.6-1.7 3.7 0.8 1.2 1.3 1 0.1 3-1.2 2.7-2 2.4-2.3 1.7-5.7 2.9-10 13.2-4.1 2.9-8.8 1.9-4.3 2-4 4-2 2.9-0.8 2.5 0.7 1.1 4.7 4.1 5.9 11.5 0.6 10.7-4.4 9.4-8.8 7.7-2.2 0.7-4.1 0.5-2.1 1.5-1.4 3-0.4 3.3 0 3.3-1.1 8.3-0.4 0.6-1.9 4.3-0.2 0.6-2.5 3.3-1.4 1.2-2 0.6-14.3 3.2-2.9 2.4-2.2 4.2-0.5 5.5-4.2 0.2-0.2 0.4-0.6 3 0.1 1.5-0.4 1-2.6 1.4-1.1-0.1-3.6-1.1-5.6 0.1-9.7-3.5-1.9 0.2-1.6 0.7-1.6 0.4-2.5-0.8-0.3-0.8-3.8-5.5-3-2.8-3.2-1.9-20.5-5.1-3.4 1.7-1.9 3.3-2.3 2.9-4.2 0.6-6 2.6-11.9 8.7-6.4 2.3-15.2-1.6-2.6 0.9-5.7 3.5-12.4 5.1-6.1 1.2-6.6 0.1-6.2-1.3-4.7-2.8-9-10.2-1.4-2.3-1.1-2.9-1.4-5.3-2.3-6-0.7-3.1-1-0.7-13.7-15.4-4.5-2.1-1.7 0.7-1.5 1.5-1.5 1.2-1.9-0.3-1.8-1.3-0.1-0.9 0.4-1.2-0.1-2.3 0.3-0.3 0-3-0.4-2.9-0.6 0.3 1-1.5 1.6-2 1.4-2.2 0.2-2.2-3.1-3-16-3.6-1.8-4.9 1.9-9.9 3.5-10.4 7.1-14-4.6-7.9-7.1-7.6-3.8-6.7 1-3.3 5.3-6.3 1.5-4.9-0.2-2.8-0.3-2.7-1.8-2.9-3.1-1.5-30-7.8-13.4-0.4-12.9 2.5-17.2 11.8-6.6 1.7-6.6 0.3-6.2 2-6.5 5.7-5.8 7.6-4.2 5.8-1.1 4 0.8 2.9 1.9 5 0.1 1.2 1.9 4.8 0.9 1.2 2.1 1.1 3.4-1.5 1.4 0.6 1 6.7-5.2 5.5-12.9 8.6-10.3 12.1-6.5 3.3-6.9-3-9.1 0.3-9.2 2.2-4.8 2.9 2.7-6.3 1.5-2.9 0.6-2.5-3.5-4.5-2.1-4 0.7-3.5 4.9-3.1 12.1-6 0.3-0.1 0.4 0 0.3 0 1.6 0.5 1.2 0.2 1.2-0.2 4.4-1.3 0.9-2-0.2-2.7 0.1-3.1 1.5-8.3 0.6-2.3 3-6.5 3.5-8.1-0.2-3.2-2.5-4.4-2.9-3.2-9.9-6.1-1-0.6 2.3-2.3 0.4-1.9-0.4-2 0-2.2-0.2-0.9-0.5-1.2-0.4-1.4 0-1.5 0.8-1.8 2.3-2.4 7-12.1 7.1-9-4.9-5.5-0.6-3.9 2.7-3.5 27.1-24.9 14.5-7.9 2-1.7 5.3-6 6.6-3.6 2.2-1.6 2.2-2.8 0.8-2.5-0.1-4.9-1.5-1.7-1-1.4-0.6-1.7 0.3-1.4 3.2-9.6 1.4-2.5 0.3-1 0.8-1.9 0.3-4-0.6-3.3-2.7-5.1-0.9-2.7 3-10.4 9.8-5.6 21.7-6.9 13.4-10.2 4.6-6.7-2.4-5.5 2.7-4.7 1.9-1.9 5.1-1.8 0.7-1.9 0.8-0.5 2.9-1.5-0.3-5 6.1-2.2 12.7-11.8 0.5-0.4 3.8-6.4 5.9-6 13.6-10.1-0.8-7.3 1.3-6.1 3.8-3.9 1.8-0.3 1.1-0.4 3-4 2.1-1.2 2-0.6 1.9-1.2 1.6-3.3-2.1-3-3-2.7-3-2.5-3.8 1.8-23.9 2.4 1-3.8 2.5-4.7 3-3.9 5.1-3.1 0.4-5.6 5.2-1.2 3.3-1.8 3-2.6 1.5-2.5-0.9-3.6-2.1-4.1-0.5-3.3 3.7-1.2 1.8-1.4 1.8-0.4 1.9 0.4 1.8 1.4 5.2 0.8 10.1-1.8 4.7 1 2.6 1.6 0.4 0 2.3 0.4 5.5-0.6-3.7 8.5 1.2 4.9 4.3 2.6 6 1.9 0.8 0.6 0.6 1.1 0.8 1.1 1.5 0.6 1.4-0.2 7.6-3.4 5.3-1.1 5.6 0.2 8.4 0.4 2-0.8 3.6-1.5 2.9-3.7 1.1-1.5 0.6-2.8-0.3-1.6-1-1.4-0.6-0.8-1-1.8-0.1-1.8 2.4-0.7 3.1 1.1 0.9 0.5 1.7 1.1 2.6 0.4 3.1-2.8 0.4-0.5 0.2-0.8 0.1-0.8-0.1-0.1-0.1-0.6-1.5-2.1-0.4-1.2 0.2-0.9 1.2-0.6 2.1 0.4 1.6-0.5 0.9-1.7-0.1-3-0.7 0-3.3-2.6-0.5-0.2 7.7-6.3 1.1-0.9 4.8-2.7 7.1-2.7 0.1 0 10.3-3.1 4.6-0.5-2.7 7.5-2.1 2.1-4.8-0.1-0.5 0 7.5 4 2.9 1.5 4.5 0.6 8.8-1.8 7.9-1.7 3.8-2.1 3.2-3.9 3.7-5.7 2.8 1.4 13 0.8 1.3 1.3 0.6 2.8 0.4 2.8 0.5 1.3 26.3 0 9-2.1 2-1.3 0.9-1.3 0.8-1.5 1.7-2 1.6-1.3 4.4-2.3 3.7-1.1 1.4-1.5 1-1.5 1-0.6 10.9-1.9 3.6 0 5.3 1.6 2.3 0.3 1.1 1.3 1.1 2.8 1.4 2.9 1.9 1.3 7.7 2.1 12.9 0 0.6-0.1 5.6-0.9 0.2-1.4 2.4-5.2 6.2-4 6-0.7 3.1 3 2.4 4 0.4 0.5 1.8 2.3 2.7-1 0.5-0.7 0.8-1.6 0.3-2.2-0.1-2.1 0.2-2.1-0.1-1-0.5-1.2-0.3-1.3 0.5-1.7 0.7-0.6 1.1-0.4 0.8 0 0.2 0.4 0.2 1.9 1.3 0.6 1.1-7-1.8-0.2-1-0.4-2.3-1-2.8-0.4-9.7 1.6-3.1 1.6-2.8 2-2.9 1.5-3.6 0.2-4.2-2.4-5.1-4-1-0.1-3.2-1.2 1.3-3.2-0.5-2.6-0.9-2.2 0.3-2.2 1.9-2.2 5.1-2.9 2.2-2 1.5-6 0.9-2.1 2.8-4.1 1.5-0.9 2.3 0 10.8-2.1 3.1-1.6-1.9-4.7 3.2-1.8 5 0.2 3.8 1.7 0.3 2.2 0.2 3.9 0.7 3.6 2 1.5 2.4-1.6 1.1-6.6 1.8-1.9 2.6 0.9 2 2.9 1.5 3.5 1.5 2.4 2.1 0.5 2.3-0.5 1.9 0.4 1.4 3-0.6 1.1-2.7 4.1-0.6 1.9 0.8 2.5 1.6 2 0.5 2.3 0.4 1.9 10.7-0.2-1.7-1.8 1.8-5.9 5.4 0.3 6.6 3.8 5.2 5-3.7 0.8 0 2.1 2.9 2.9 0.1 0.1 5.9 4.4 4.9 1.3 7.9-0.8 7.4-2.3 3.2-3.5 3.8-1.5 22.4 2.5 11.2 0 2.7 4.3 7.6 0 7.8 1.8 55.2 34.5 1.2 5.3 0.4 1.8 5.9 9 7.5 3.4 5.8 5.1-0.2 12.6-2 4.6-7.8 9.9-0.9 2.6-1 5.3-0.8 2-6.9 8.3-6.5 11-3.3 5.7-3.5 10-0.4 10 1.5 4.9 2.2 4.2 1.7 4.8 0.1 6.3-1.9 4-3.1 3.1-2.4 3.2 0.2 2.8 4.6 1.3 12.3 2.1 4.1-1.4 3.8 1 10.6-1.3 3.3 0.5 38.1 12.1-0.3 3.3 0.8 0.8 1.3-0.1 0.7 0.9 0 1.7-0.8 2.9-0.5 6.9-0.6 3.2 0.3 2.7 2.6 3.7 5 3.8 21.5 7 7.8 7.4 4.5 2.7 8.8 2.8 2.7 0.1 1.4 0 5.2-1.5 8.8-4.4 2.1-3.1 0.5-2.2 0.2-2.5 0.9-3.7 3.1-5.2 3.3-0.6 3.9 1 5-0.2 0.1-5.5 3.5-6.8 5.1-5.9 5.9-3.3 1.1-0.2 1.1 0.2 1 0.7 0.1 0 2.1 2.3 4.2 6.8 6.8 5.4 1.8 2.2 1.1 4.9-2.5 10.1 0.5 6.3z"
      fill="none"
      stroke="#FFD700"
      strokeWidth="2"
    />
    {/* Location marker for Aargau (northern Switzerland) */}
    <circle cx="540" cy="175" r="10" fill="#FFD700" className="animate-pulse" />
    <circle cx="540" cy="175" r="20" fill="none" stroke="#FFD700" strokeWidth="1" opacity="0.5" />
    {/* Location marker for Ticino (the southern tip of Switzerland) */}
    <circle cx="640" cy="510" r="10" fill="#FFD700" className="animate-pulse" />
    <circle cx="640" cy="510" r="20" fill="none" stroke="#FFD700" strokeWidth="1" opacity="0.5" />
  </svg>
);

// Flying envelope animation
const FlyingEnvelope = ({ isVisible }) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        className="fixed inset-0 flex items-center justify-center pointer-events-none z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          initial={{ scale: 0.5, y: 100, rotate: 0 }}
          animate={{ 
            scale: [0.5, 1, 0.8],
            y: [100, 0, -500],
            rotate: [0, 10, -5],
            opacity: [1, 1, 0]
          }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="text-8xl"
        >
          <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="1.5">
            <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

const ContactSection = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.substring(0, 2) || 'it';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showEnvelope, setShowEnvelope] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    
    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (!response.ok) {
        throw new Error('Errore nell\'invio del messaggio');
      }
      
      // Show flying envelope animation
      setShowEnvelope(true);
      setTimeout(() => setShowEnvelope(false), 1500);
      
      // Track Google Ads conversion on successful form submission
      if (typeof window.gtag_report_conversion === 'function') {
        window.gtag_report_conversion();
      }
      
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({ name: '', email: '', company: '', message: '' });
      }, 3000);
    } catch (err) {
      setError(t('contact.form.error') || 'Si è verificato un errore. Riprova più tardi.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <section id={sectionId(lang, 'contact')} className="py-32 bg-[#0a0a0a] relative overflow-hidden">
      {/* Flying envelope animation */}
      <FlyingEnvelope isVisible={showEnvelope} />
      
      {/* Top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FFD700]/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          className="text-center mb-24"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {/* Unique selling point */}
          <div className="mb-8 px-4">
            <span className="text-[11px] sm:text-xs tracking-[0.1em] uppercase text-white/70">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#FFD700] mr-1.5 align-middle" />
              {t('contact.usp')}
            </span>
          </div>

          <span className="text-[#FFD700] text-xs tracking-[0.4em] uppercase mb-6 block">
            {t('contact.subtitle')}
          </span>
          <h2 className="font-display text-6xl md:text-7xl lg:text-8xl text-white leading-[0.9] mb-8">
            {t('contact.title')}
          </h2>
          <p className="text-white/80 text-lg font-light max-w-2xl mx-auto">
            {t('contact.description')}
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-20">
          {/* Form */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <form onSubmit={handleSubmit} className="space-y-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-2">
                  <label className="text-white/80 text-xs tracking-[0.2em] uppercase">{t('contact.form.name')} *</label>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.form.name_placeholder')}
                    className="bg-transparent border-0 border-b border-white/20 rounded-none px-0 py-4 text-white placeholder:text-white/20 focus:border-[#FFD700] focus:ring-0 transition-colors duration-500"
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-white/80 text-xs tracking-[0.2em] uppercase">{t('contact.form.email')} *</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.form.email_placeholder')}
                    className="bg-transparent border-0 border-b border-white/20 rounded-none px-0 py-4 text-white placeholder:text-white/20 focus:border-[#FFD700] focus:ring-0 transition-colors duration-500"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-white/80 text-xs tracking-[0.2em] uppercase">{t('contact.form.company')}</label>
                <Input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder={t('contact.form.company_placeholder')}
                  className="bg-transparent border-0 border-b border-white/20 rounded-none px-0 py-4 text-white placeholder:text-white/20 focus:border-[#FFD700] focus:ring-0 transition-colors duration-500"
                />
              </div>

              <div className="space-y-2">
                <label className="text-white/80 text-xs tracking-[0.2em] uppercase">{t('contact.form.message')} *</label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  placeholder={t('contact.form.message_placeholder')}
                  className="bg-transparent border-0 border-b border-white/20 rounded-none px-0 py-4 text-white placeholder:text-white/20 focus:border-[#FFD700] focus:ring-0 resize-none transition-colors duration-500"
                />
              </div>

              <motion.button
                type="submit"
                disabled={isSubmitting || isSubmitted}
                className="elegant-button w-full py-5 text-xs tracking-[0.3em] uppercase disabled:opacity-50"
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                data-testid="contact-submit-button"
              >
                {isSubmitting ? t('contact.form.submitting') : isSubmitted ? t('contact.form.submitted') : t('contact.form.submit')}
              </motion.button>

              {/* WhatsApp Button */}
              <motion.a
                href="https://api.whatsapp.com/send/?phone=41766270882&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 w-full py-4 border border-white/20 hover:border-[#FFD700]/50 transition-all duration-500 group"
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                data-testid="whatsapp-button"
              >
                <svg 
                  className="w-5 h-5 text-[#FFD700] group-hover:scale-110 transition-transform duration-300" 
                  viewBox="0 0 24 24" 
                  fill="currentColor"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="text-white/80 text-xs tracking-[0.2em] uppercase group-hover:text-[#FFD700] transition-colors duration-300">
                  WhatsApp
                </span>
                <span className="text-[#FFD700] text-xs font-medium tracking-wider">
                  24/24
                </span>
              </motion.a>
              
              {error && (
                <p className="text-red-500 text-sm text-center mt-4">{error}</p>
              )}
            </form>
          </motion.div>

          {/* Contact Info + Map */}
          <motion.div
            className="flex flex-col"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {/* Switzerland Map */}
            <div className="relative mb-16 group">
              <SwitzerlandMap />
              {/* Aargau label - top right */}
              <div className="absolute top-4 right-4 text-right">
                <p className="text-[#FFD700] text-sm tracking-wider">{t('contact.map.aargau')}</p>
                <p className="text-white/60 text-xs">{t('contact.map.country')}</p>
              </div>
              {/* Ticino label - bottom right */}
              <div className="absolute bottom-2 right-4 text-right">
                <p className="text-[#FFD700] text-sm tracking-wider">{t('contact.map.region')}</p>
                <p className="text-white/60 text-xs">{t('contact.map.country')}</p>
              </div>
            </div>
            
            {/* Info cards - Only Email and Instagram, wider */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
              <motion.a
                href={`mailto:${contactInfo.email}`}
                className="block group p-6 md:p-8 border border-white/10 hover:border-[#FFD700]/30 transition-all duration-500"
                whileHover={{ y: -5 }}
              >
                <span className="text-[#FFD700] text-xs tracking-[0.2em] uppercase block mb-4">{t('contact.info.email_label')}</span>
                <span className="text-white text-lg md:text-xl font-light group-hover:text-[#FFD700] transition-colors duration-500 block">
                  {contactInfo.email}
                </span>
              </motion.a>

              <motion.a
                href={contactInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="block group p-6 md:p-8 border border-white/10 hover:border-[#FFD700]/30 transition-all duration-500"
                whileHover={{ y: -5 }}
              >
                <span className="text-[#FFD700] text-xs tracking-[0.2em] uppercase block mb-4">{t('contact.info.instagram_label')}</span>
                <span className="text-white text-lg md:text-xl font-light group-hover:text-[#FFD700] transition-colors duration-500 block">
                  @doubleastudioch
                </span>
              </motion.a>
            </div>

            {/* Quote */}
            <div className="border-l-2 border-[#FFD700] pl-8">
              <p className="font-serif italic text-white/80 text-xl leading-relaxed mb-4">
                "{t('contact.quote')}"
              </p>
              <p className="text-[#FFD700] text-sm tracking-wider">
                — {t('contact.quote_author')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
